<idt-common-styles-render
  *ngIf="piece"
  [styles]="settings?.styles">
    <ng-lottie
      [options]="options"
      (animationCreated)="animationCreated($event)">
    </ng-lottie>
</idt-common-styles-render>
